<script setup lang="ts">
const { locale } = useI18n();

const woodLinks = {
  cs: 'https://wood.cz',
  en: 'https://wood.com',
} as const;
const currentYear = new Date().getFullYear();
const woodLink = computed(() => woodLinks[locale.value as 'cs' | 'en']);
</script>

<template>
  <div class="copyright">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="copyright__company-info">
            <a target="_blank" :href="woodLink" :title="$t('layout.footer.copyright.links.wood')">
              <svg height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 149 61">
                <path
                  d="M8.64,36.88h9.16l5.73-17.46,5.68,17.46h8.88L46.84,3.65h-7.06l-6.26,25.11L23.64,0,13.71,28.76,7.45,3.65H0L8.64,36.88ZM141.74,20.22c0,5.74-4.2,10.01-9.93,10.01h-6.88V10.3h6.88c5.73,0,9.93,4.22,9.93,9.92Zm-53.3,.05c0-5.74,4.49-10.35,10.22-10.35s10.22,4.6,10.22,10.35-4.49,10.35-10.22,10.35-10.22-4.56-10.22-10.35Zm-36.39,0c0-5.74,4.49-10.35,10.22-10.35s10.22,4.6,10.22,10.35-4.49,10.35-10.22,10.35-10.22-4.56-10.22-10.35h0Zm96.94-.05c0-9.16-7.64-16.56-17.19-16.56h-13.93V36.88h13.94c9.5,0,17.19-7.45,17.19-16.66h0Zm-32.85,.05c0-9.54-7.74-17.18-17.48-17.18s-17.48,7.64-17.48,17.18,7.79,17.17,17.48,17.17,17.48-7.64,17.48-17.17h0Zm-36.39,0c0-9.54-7.74-17.18-17.48-17.18s-17.48,7.64-17.48,17.18,7.78,17.17,17.48,17.17,17.49-7.64,17.49-17.17m45.58,33.32l-3.07-8.29h-3.22l4.66,11.71-1.59,3.99h3.03l6.26-15.71h-3.03l-3.04,8.29Zm-10.97-8.51c-.68-.01-1.36,.14-1.98,.43-.62,.29-1.16,.73-1.57,1.27v-1.47h-2.98v11.32h2.98v-6.35c0-1.47,1.1-2.5,2.58-2.5s2.57,1.03,2.57,2.5v6.34h2.98v-6.87c0-2.7-1.85-4.67-4.59-4.67h0Zm-14,9.41c-.91,0-1.46-.46-1.46-1.14s.53-1.1,1.39-1.2l1.92-.22c.49-.06,.82-.13,1.02-.28v.24c0,1.35-1.3,2.61-2.88,2.61h0Zm.99-9.41c-2.91,0-4.79,1.54-5.1,3.49l2.96,.66c.2-1.07,.97-1.71,2.16-1.71,1.06,0,1.85,.53,1.85,1.35,0,.59-.35,.85-1.06,.9l-1.85,.18c-2.12,.22-4.39,1.05-4.39,3.64,0,2,1.59,3.25,3.71,3.25,.68,.01,1.36-.13,1.98-.4,.62-.28,1.17-.68,1.62-1.2v1.38h2.98v-7.16c0-2.98-2.1-4.39-4.86-4.39h0Zm-12.36,9.06c-1.7,0-3-1.35-3-3.18s1.3-3.16,3-3.16,3,1.35,3,3.16-1.28,3.18-3,3.18Zm.62-9.06c-.68-.01-1.36,.12-1.98,.39-.62,.27-1.18,.67-1.64,1.17v-1.34h-2.96v15.71h2.98v-5.72c.46,.5,1.02,.9,1.64,1.17,.62,.27,1.3,.4,1.98,.39,3.11,0,5.47-2.54,5.47-5.88s-2.36-5.87-5.47-5.87h-.02Zm-12.72,0c-.69,0-1.38,.16-1.99,.48-.62,.32-1.14,.78-1.54,1.34-.36-.57-.86-1.03-1.45-1.35-.59-.32-1.26-.48-1.93-.47-1.3,0-2.36,.61-3.11,1.58v-1.35h-2.98v11.32h2.98v-6.36c0-1.47,.93-2.5,2.14-2.5s2.14,1.03,2.14,2.5v6.34h2.98v-6.34c0-1.47,.93-2.5,2.14-2.5,1.28,0,2.16,1.03,2.16,2.5v6.34h2.99v-6.87c0-2.7-1.83-4.67-4.52-4.67h0Zm-23.15,5.87c0-1.8,1.3-3.16,3-3.16s3,1.35,3,3.16-1.28,3.18-3,3.18-3-1.35-3-3.18Zm-3.09,0c0,3.33,2.63,5.88,6.09,5.88s6.09-2.54,6.09-5.88-2.63-5.87-6.09-5.87-6.09,2.54-6.09,5.87Zm-15.74-2.02c0,4.45,3.53,7.9,8.12,7.9,3.6,0,6.18-2.15,7.22-4.45l-2.91-1.12c-.39,.81-.99,1.49-1.76,1.97-.76,.48-1.65,.73-2.55,.73-2.74,0-4.86-2.19-4.86-5.02s2.12-5.02,4.86-5.02c.9,0,1.79,.25,2.55,.73,.76,.48,1.37,1.16,1.76,1.97l2.91-1.12c-1.04-2.3-3.62-4.45-7.22-4.45-4.59,0-8.12,3.44-8.12,7.9h0Zm-11.1,5.35c-1.48,0-2.36-.81-2.36-1.84,0-.85,.55-1.49,1.36-2.02,1.16,1.11,2.4,2.13,3.71,3.07-.8,.54-1.75,.81-2.71,.79h0Zm.55-10.7c.21,0,.41,.03,.6,.1,.19,.07,.37,.19,.51,.33,.15,.14,.26,.31,.34,.5,.08,.19,.12,.39,.11,.6,0,1.16-1.04,1.82-2.21,2.46-.64-.79-1.04-1.54-1.04-2.19,0-1.07,.71-1.8,1.68-1.8h0Zm8.76,10.9c-.77-.42-1.63-.94-2.52-1.49,.66-1.38,.86-3.03,.46-4.78h-2.85c.28,1.04,.26,2.13-.07,3.16-1.07-.71-2.09-1.51-3.05-2.37,2.12-.75,3.6-2.17,3.6-4.19,0-1.87-1.52-3.77-4.3-3.77-3.03,0-4.66,1.96-4.66,4.04,0,1.18,.6,2.46,1.59,3.71-1.81,.79-2.96,2.13-2.96,3.79,0,2.33,1.97,4.26,5.34,4.26,2.12,0,3.91-.64,5.19-1.71,.95,.61,1.9,1.18,2.8,1.71l1.41-2.35Z"
                  fill="black"
                />
              </svg>
            </a>

            <span>
              {{ $t('layout.footer.copyright.company', { year: currentYear }) }}
              <br />
              {{ $t('layout.footer.copyright.address') }}
            </span>
          </div>
        </div>

        <div class="col additional-products">
          <a
            href="https://www.portu.cz"
            target="_blank"
            :title="$t('layout.footer.copyright.links.portu')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="32"
              viewBox="0 0 120 41"
              :aria-label="$t('layout.footer.copyright.logos.portu')"
            >
              <path
                d="m19.561 19.167 18.057 10.536L19.56 40.239 1.505 29.703 19.56 19.167Zm0-.888L0 29.703l19.561 11.424 19.561-11.424-19.56-11.424Z"
                fill="#14C850"
              />
              <path
                d="M38.997 11.424 19.56 22.848 0 11.424 19.561 0l19.436 11.424Z"
                fill="#14C850"
              />
              <path d="M19.561 22.849v9.139L0 20.564v-9.14L19.561 22.85Z" fill="#00A03C" />
              <path d="M19.562 22.849v9.139l19.436-11.424v-9.14L19.562 22.85Z" fill="#008C32" />
              <path
                d="M62.32 20.709c0 4.062-2.633 7.235-6.27 7.235-1.755 0-2.884-.634-3.761-1.65v5.84l-4.264 2.538V13.854h4.138v1.524c.878-1.016 2.006-1.904 3.887-1.904 3.637 0 6.27 3.173 6.27 7.235Zm-10.157 0c0 1.777 1.129 3.173 2.884 3.173 1.756 0 2.884-1.396 2.884-3.173 0-1.777-1.128-3.174-2.884-3.174-1.755 0-2.884 1.27-2.884 3.174Zm26.458 0c0 4.189-3.134 7.235-7.398 7.235-4.263 0-7.272-3.046-7.272-7.235s3.134-7.235 7.272-7.235c4.264 0 7.398 3.046 7.398 7.235Zm-10.282 0c0 1.904 1.254 3.173 2.884 3.173 1.756 0 2.884-1.27 2.884-3.173 0-1.904-1.254-3.174-2.884-3.174s-2.884 1.27-2.884 3.174Zm21.941-6.982-.375 4.316c-.627-.254-1.38-.38-2.132-.38-1.505 0-2.508.761-2.508 2.411v7.362h-4.263V13.854h4.138v1.524c.752-1.397 2.006-1.904 3.636-1.904.627 0 1.254.127 1.505.253Zm8.78 3.936v4.061c0 1.524.877 2.158 1.88 2.158.752 0 1.63-.507 2.383-.888l1.504 3.427c-1.254.889-2.633 1.523-4.765 1.523-3.636 0-5.266-2.158-5.266-5.585v-4.697h-2.508v-3.807h2.508V9.538L99.059 7v6.854h4.64v3.809h-4.64Zm14.42 10.281c-3.637 0-6.521-1.904-6.521-6.22v-7.87h4.264v7.49c0 1.777.877 2.538 2.257 2.538 1.379 0 2.257-.761 2.257-2.538v-7.49H120v7.87c0 4.19-3.009 6.22-6.52 6.22Z"
                fill="#1E0A46"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.copyright {
  margin-top: 6.25rem;
  padding-block: 1.875rem;

  background-color: var(--white);

  font-size: var(--font-size-xs);

  .row {
    row-gap: 1.25rem;
  }
}

.copyright__company-info {
  display: flex;
  flex-direction: column;
  row-gap: 0.625rem;

  div {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
  }

  @media (min-width: 768px) {
    align-items: center;
    flex-direction: row;

    svg {
      margin-right: 1.875rem;
    }
  }
}

.additional-products {
  display: flex;
  flex: 0;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    @media (max-width: 1440px) {
      padding-right: 110px;
    }
  }
}
</style>
